import { render, staticRenderFns } from "./InviteRegister.vue?vue&type=template&id=6e8643e6&"
import script from "./InviteRegister.vue?vue&type=script&lang=js&"
export * from "./InviteRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports